import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../axios';
const moduleName = 'aKademy';

export const getAllAkademySchools = createAsyncThunk(
  `${moduleName}/getAllAkademySchools`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/schools',
        params: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademySchool = createAsyncThunk(
  `${moduleName}/createAkademySchool`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/school',
        data: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademySchool = createAsyncThunk(
  `${moduleName}/updateAkademySchool`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/school/${id}`,
        data: { ...data },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSchoolById = createAsyncThunk(
  `${moduleName}/getAkademySchoolById`,
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/akademy/school/${id}`,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const getAllAkademyUsers = createAsyncThunk(
  `${moduleName}/getAllAkademyUsers`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/profile/akademy/users',
        params: paylaod,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademyUser = createAsyncThunk(
  `${moduleName}/createAkademyUsers`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/profile/akademy/user',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademyUser = createAsyncThunk(
  `${moduleName}/updateAkademyUser`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/profile/akademy/user/${id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const bulkUploadAkademyUsers = createAsyncThunk(
  `${moduleName}/bulkUploadAkademyUsers`,
  async (payload, { rejectWithValue }) => {
    const data = new FormData();
    const KEY = 'file';
    data.append(KEY, payload.file);

    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/common/upload/users',
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addMasterCoordinatorProfile = createAsyncThunk(
  `${moduleName}/addMasterCoordinatorProfile`,
  async (payload, { rejectWithValue }) => {
    const { id } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `profile/akademy/user/${id}/profiles`,
        data: {
          role: 'MASTER_CO_ORDINATOR',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const getAllAkademyProgrammes = createAsyncThunk(
  `${moduleName}/getAllAkademyProgrammes`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/bcc/school/programmes',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademyProgramme = createAsyncThunk(
  `${moduleName}/createAkademyProgramme`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/bcc/school/programme',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademyProgramme = createAsyncThunk(
  `${moduleName}/updateAkademyProgramme`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/bcc/school/programme/${id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAkademyProgramme = createAsyncThunk(
  `${moduleName}/deleteAkademyProgramme`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id } = payload;
      const response = await axiosBuzzOne({
        method: 'DELETE',
        url: `/akademy/bcc/school/programme/${id}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const getAllAkademyClasses = createAsyncThunk(
  `${moduleName}/getAllAkademyClasses`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/bcc/school/classes',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademyClass = createAsyncThunk(
  `${moduleName}/createAkademyClass`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/bcc/school/class',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademyClass = createAsyncThunk(
  `${moduleName}/updateAkademyClass`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/bcc/school/class/${id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAkademyClass = createAsyncThunk(
  `${moduleName}/deleteAkademyClass`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id } = payload;
      const response = await axiosBuzzOne({
        method: 'DELETE',
        url: `/akademy/bcc/school/class/${id}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const getAllAkademyLanguages = createAsyncThunk(
  `${moduleName}/getAllAkademyLanguages`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/bcc/user/languages',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademyLanguage = createAsyncThunk(
  `${moduleName}/createAkademyLanguage`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/bcc/user/language',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademyLanguage = createAsyncThunk(
  `${moduleName}/updateAkademyLanguages`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/bcc/user/language/${id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAkademyLanguage = createAsyncThunk(
  `${moduleName}/deleteAkademyLanguages`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id } = payload;
      const response = await axiosBuzzOne({
        method: 'DELETE',
        url: `/akademy/bcc/user/language/${id}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

export const getAllBuddyTalktimePlans = createAsyncThunk(
  `${moduleName}/GET/buddy/talktime/plans`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/buddy_talktime/plans',
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createBuddyTalktimePlan = createAsyncThunk(
  `${moduleName}/POST/buddy/talktime/plans`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/buddy_talktime/plans',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBuddyTalktimePlan = createAsyncThunk(
  `${moduleName}/PUT/buddy/talktime/plans`,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/buddy_talktime/plans/${id}`,
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

export const getAIChatHistory = createAsyncThunk(
  `${moduleName}/GET/AI/chat/history`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/AIChat/history',
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
////////////////////////////////////////////////////////////////

export const getAllAkademyIndicatorStatutories = createAsyncThunk(
  `${moduleName}/getAllAkademyIndicatorStatutories`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: '/akademy/development/statutories',
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAkademyIndicatorStatutories = createAsyncThunk(
  `${moduleName}/createAkademyIndicatorStatutories`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: '/akademy/development/statutories',
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkademyIndicatorStatutories = createAsyncThunk(
  `${moduleName}/updateAkademyIndicatorStatutories`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/development/statutories/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

// Curriculum v2 — `akademy/bcc/curriculum/v2/*`.
//
// Two things differ from every other thunk in this file:
//
// 1. **No response envelope.** These handlers return the Mongoose document, or a plain
//    array of them, directly — not the `{ data, message }` envelope the statutory thunks
//    above still use. So the reducers below read `action.payload` rather than
//    `action.payload.data`, and the screens supply their own success copy instead of
//    echoing `res.message`.
// 2. **Almost no DELETE.** Nodes are referenced by id from observations, reports and
//    assessments with no snapshot of their text, so a hard delete would leave those rows
//    rendering a hole — the disabled delete buttons on the node screens are the contract.
//    The one exception is a framework draft that was never published: nothing can
//    reference it yet. Everything else is archived instead.
const CURRICULUM_V2 = '/akademy/bcc/curriculum/v2';

export const getAllCurriculumFrameworks = createAsyncThunk(
  `${moduleName}/getAllCurriculumFrameworks`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/frameworks`,
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCurriculumFramework = createAsyncThunk(
  `${moduleName}/createCurriculumFramework`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/frameworks`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCurriculumFramework = createAsyncThunk(
  `${moduleName}/updateCurriculumFramework`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `${CURRICULUM_V2}/frameworks/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Framework lifecycle: DRAFT ─publish→ PUBLISHED ─archive→ ARCHIVED, unpublish back to
// DRAFT (newest version only), restore ARCHIVED → DRAFT, duplicate-version turns a
// PUBLISHED framework into a new DRAFT at version + 1. Only a published Global appears in
// schools' adopt list. Refusals are 409s with a `code` — see the backend's curriculum
// API.md §2.
const frameworkLifecycleThunk = (name, verb) =>
  createAsyncThunk(
    `${moduleName}/${name}`,
    async (payload, { rejectWithValue }) => {
      try {
        const response = await axiosBuzzOne({
          method: 'POST',
          url: `${CURRICULUM_V2}/frameworks/${payload._id}/${verb}`,
        });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

// Resolves to `{ framework, classesApplied, warning? }`.
export const publishCurriculumFramework = frameworkLifecycleThunk(
  'publishCurriculumFramework',
  'publish'
);
export const unpublishCurriculumFramework = frameworkLifecycleThunk(
  'unpublishCurriculumFramework',
  'unpublish'
);
export const archiveCurriculumFramework = frameworkLifecycleThunk(
  'archiveCurriculumFramework',
  'archive'
);
export const restoreCurriculumFramework = frameworkLifecycleThunk(
  'restoreCurriculumFramework',
  'restore'
);
// DRAFT_ALREADY_EXISTS carries the existing draft's `frameworkId` and `version`.
export const duplicateCurriculumFrameworkVersion = frameworkLifecycleThunk(
  'duplicateCurriculumFrameworkVersion',
  'duplicate-version'
);

// A draft that was never published (no `firstPublishedAt`) only.
export const deleteCurriculumFramework = createAsyncThunk(
  `${moduleName}/deleteCurriculumFramework`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'DELETE',
        url: `${CURRICULUM_V2}/frameworks/${payload._id}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Recomputes every derived cache on every node in the framework (`frameworkCode`,
// `levelName`, `ancestors`, `ancestorPath`) from `parentId` + `framework.levels`.
// Resolves to `{ totalNodes, updated, skipped }`. Run on suspected drift, not routinely.
export const rebuildCurriculumFrameworkCaches = createAsyncThunk(
  `${moduleName}/rebuildCurriculumFrameworkCaches`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/frameworks/${payload._id}/rebuild-caches`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

// `frameworkId` is required; `level`, `parentId`, `ageGroupIds` (repeat the param or pass
// an array — matches a node tagged with *any* of them) and `searchText` narrow it.
// `level<N>Item=<value>` (e.g. `level1Item=Physical Development`) is one query param per
// ancestor level, matched against the node's own level/value or its cached `ancestorPath`
// — this is what lets a level ≥ 2 fetch ask for one branch instead of a whole level.
// There is no server-side pagination, so callers should always scope by at least `level`
// rather than fetching a whole framework's nodes in one call.
export const getCurriculumNodes = createAsyncThunk(
  `${moduleName}/getCurriculumNodes`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/nodes`,
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCurriculumNode = createAsyncThunk(
  `${moduleName}/createCurriculumNode`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/nodes`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// `value`, `level`, `parentId` and `ageGroupIds` all move through this one call because
// they are not independently settable: a child's level must exceed its parent's, so
// re-levelling and reparenting have to be applied together or a legal target state is
// unreachable in either order.
//
// For `parentId`/`ageGroupIds` an **absent key means "leave unchanged"** and an explicit
// **`null` means "clear it"** (make the node a root / drop every age group). Do not run
// this payload through `sanitizePayload` — it strips nulls and would silently turn every
// clear into a no-op.
//
// `ageGroupIds` **replaces the whole set rather than merging into it**, so always send the
// complete list (`[]` clears it, same as `null`); there is no add-one/remove-one endpoint.
// Every id must belong to the node's own framework — one that doesn't rejects the entire
// request instead of being dropped from the set.
export const updateCurriculumNode = createAsyncThunk(
  `${moduleName}/updateCurriculumNode`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `${CURRICULUM_V2}/nodes/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Generated `.xlsx` (one `L<level>` column per level the framework declares, plus a
// legend sheet) — `responseType: 'blob'` since this is a binary file, not JSON.
export const getCurriculumNodesImportTemplate = createAsyncThunk(
  `${moduleName}/getCurriculumNodesImportTemplate`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/nodes/import-template`,
        params: payload,
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Bulk-creates a framework's node tree from an uploaded `.xlsx` (each row a root-first
// path, one value per declared level; a blank mid-row column skips that level). Nodes are
// found-or-created by exact `(parent, level, value)`, so re-uploading an edited sheet is
// safe and never duplicates. Whole-file atomic: any row error 400s with every row's error
// at once (`{message, errors: string[]}`) and nothing is written.
//
// `ageGroupMinMonth`/`ageGroupMaxMonth` tag the row's deepest filled column, and the band
// is found-or-created. Since a node holds a *set* of age groups, tagging one node with
// several bands is one row per band with the `L` columns repeated identically — bands
// accumulate across rows, a later row never replaces what an earlier one tagged.
export const importCurriculumNodes = createAsyncThunk(
  `${moduleName}/importCurriculumNodes`,
  async ({ frameworkId, file }, { rejectWithValue }) => {
    try {
      const data = new FormData();
      data.append('frameworkId', frameworkId);
      data.append('file', file);
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/nodes/import`,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

export const getCurriculumAgeGroups = createAsyncThunk(
  `${moduleName}/getCurriculumAgeGroups`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/age-groups`,
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCurriculumAgeGroup = createAsyncThunk(
  `${moduleName}/createCurriculumAgeGroup`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/age-groups`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCurriculumAgeGroup = createAsyncThunk(
  `${moduleName}/updateCurriculumAgeGroup`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `${CURRICULUM_V2}/age-groups/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

// Replaces v1's development grades. Returned sorted by `order` (1 = top of the scale).
export const getCurriculumRatingScales = createAsyncThunk(
  `${moduleName}/getCurriculumRatingScales`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/rating-scales`,
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCurriculumRatingScale = createAsyncThunk(
  `${moduleName}/createCurriculumRatingScale`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/rating-scales`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCurriculumRatingScale = createAsyncThunk(
  `${moduleName}/updateCurriculumRatingScale`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `${CURRICULUM_V2}/rating-scales/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

////////////////////////////////////////////////////////////////

// `nodeId` is required — suggestions carry no `frameworkId` of their own, so the backend
// cannot scope-check a query without one. A node may hold many suggestions; the pair
// `{nodeId, ageGroupId}` is unique.
export const getCurriculumActionSuggestions = createAsyncThunk(
  `${moduleName}/getCurriculumActionSuggestions`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/action-suggestions`,
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCurriculumActionSuggestion = createAsyncThunk(
  `${moduleName}/createCurriculumActionSuggestion`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/action-suggestions`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Only the two text fields are updatable — `nodeId` and `ageGroupId` are fixed at
// creation, so re-pointing a suggestion means creating a new one.
export const updateCurriculumActionSuggestion = createAsyncThunk(
  `${moduleName}/updateCurriculumActionSuggestion`,
  async (payload, { rejectWithValue }) => {
    try {
      const { _id, ...data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `${CURRICULUM_V2}/action-suggestions/${_id}`,
        data: { ...data },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Same generated-`.xlsx` shape as the nodes template — `responseType: 'blob'` since this
// is a binary file, not JSON.
export const getCurriculumActionSuggestionsImportTemplate = createAsyncThunk(
  `${moduleName}/getCurriculumActionSuggestionsImportTemplate`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `${CURRICULUM_V2}/action-suggestions/import-template`,
        params: payload,
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Unlike node import, this never creates nodes or age groups — an unresolved `L`-path or
// unmatched age band is a per-row error, not something to invent on the fly (import nodes
// first, or create the age group directly). Never upserts either: there's no natural key
// to de-duplicate a `(node, ageGroup)` pair against, so re-uploading the same sheet
// appends duplicates — this is "add these," not "sync to this." Whole-file atomic, same
// reasoning as node import.
export const importCurriculumActionSuggestions = createAsyncThunk(
  `${moduleName}/importCurriculumActionSuggestions`,
  async ({ frameworkId, file }, { rejectWithValue }) => {
    try {
      const data = new FormData();
      data.append('frameworkId', frameworkId);
      data.append('file', file);
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `${CURRICULUM_V2}/action-suggestions/import`,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createStoragePlanAsync = createAsyncThunk(
  `${moduleName}/createStoragePlanAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `storage/plans`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const allStoragePlanAsync = createAsyncThunk(
  `${moduleName}/allStoragePlanAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `storage/plans`,
        params: { currency: payload },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Token plan
export const createTokenPlanAsync = createAsyncThunk(
  `${moduleName}/createTokenPlanAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `token/plans`,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const allTokenPlanAsync = createAsyncThunk(
  `${moduleName}/allTokenPlanAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `token/plans`,
        params: { currency: payload },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const enableAkadmyWidget = createAsyncThunk(
  `${moduleName}/akadmyWidget/enable`,
  async (payload, { dispatch, rejectWithValue }) => {
    const { schoolId } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `/akademy/widget/${schoolId}/enable`,
      });
      dispatch(getAkadmyWidgetConfig({ schoolId }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const disableAkadmyWidget = createAsyncThunk(
  `${moduleName}/akadmyWidget/disable`,
  async (payload, { dispatch, rejectWithValue }) => {
    const { schoolId } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: `/akademy/widget/${schoolId}/disable`,
      });
      dispatch(getAkadmyWidgetConfig({ schoolId }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAkadmyWidgetConfig = createAsyncThunk(
  `${moduleName}/getAkadmyWidgetConfig`,
  async ({ schoolId }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/akademy/widget/configs/${schoolId}`,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAkadmyWidgetConfig = createAsyncThunk(
  `${moduleName}/updateAkadmyWidgetConfig`,
  async (payload, { dispatch, rejectWithValue }) => {
    const { schoolId, ...data } = payload;
    try {
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: `/akademy/widget/configs/${schoolId}`,
        data,
      });
      dispatch(getAkadmyWidgetConfig({ schoolId }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

export const getAkadmySchoolAnalytics = createAsyncThunk(
  `${moduleName}/school/analytics`,
  async ({ schoolId, ...params }, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: `/akademy/aggregation/schools/${schoolId}`,
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

/////////////////////////////////////////////////////////

const akademySlice = createSlice({
  name: `${moduleName}`,
  initialState: {
    loading: false,
    schools: [],
    school: {
      isLoading: false,
      isError: false,
      data: null,
    },
    users: [],
    programmes: [],
    classes: [],
    classesMap: {},
    languages: [],
    subscriptions: [],
    products: [],
    subscriptionPlans: [],
    licenses: [],
    talktimePlans: [],
    aiChatHistory: [],
    indicatorStatutories: [],
    // Curriculum v2. Nodes/age groups/rating scales are always scoped to one framework,
    // so these hold the selected framework's slice rather than everything.
    curriculumFrameworks: [],
    curriculumNodes: [],
    curriculumAgeGroups: [],
    curriculumRatingScales: [],
    curriculumActionSuggestions: [],
    allPlans: [],
    allTokenPlans: null,
    widgetConfig: {
      isLoading: false,
      isError: false,
      data: null,
    },
  },
  reducers: {},
  extraReducers: {
    [getAllAkademySchools.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademySchools.fulfilled]: (state, action) => {
      state.loading = false;
      state.schools = action.payload.data;
    },
    [getAllAkademySchools.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolById.pending]: (state) => {
      state.school.isLoading = true;
      state.school.isError = false;
    },
    [getSchoolById.fulfilled]: (state, action) => {
      state.school.isLoading = false;
      state.school.data = action.payload.data;
    },
    [getSchoolById.rejected]: (state) => {
      state.school.isLoading = false;
      state.school.isError = true;
    },
    [getAllAkademyUsers.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademyUsers.fulfilled]: (state, action) => {
      state.loading = false;
      state.users = action.payload.data;
    },
    [getAllAkademyUsers.rejected]: (state) => {
      state.loading = false;
    },

    /////////////////////////////////////////
    [getAllAkademyProgrammes.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademyProgrammes.fulfilled]: (state, action) => {
      state.loading = false;
      state.programmes = action.payload.data;
    },
    [getAllAkademyProgrammes.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAllAkademyClasses.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademyClasses.fulfilled]: (state, action) => {
      state.loading = false;

      const classes = action.payload.data;
      const classesMap = {};
      classes.map(({ _id, code }) => (classesMap[_id] = code));
      // classesMap['common'] = 'COMMON';

      state.classes = classes;
      state.classesMap = classesMap;
    },
    [getAllAkademyClasses.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAllAkademyLanguages.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademyLanguages.fulfilled]: (state, action) => {
      state.loading = false;
      state.languages = action.payload.data;
    },
    [getAllAkademyLanguages.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAllBuddyTalktimePlans.pending]: (state) => {
      state.loading = true;
    },
    [getAllBuddyTalktimePlans.fulfilled]: (state, action) => {
      state.loading = false;
      state.talktimePlans = action.payload.data;
    },
    [getAllBuddyTalktimePlans.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAIChatHistory.pending]: (state) => {
      state.loading = true;
    },
    [getAIChatHistory.fulfilled]: (state, action) => {
      state.loading = false;
      state.aiChatHistory = action.payload.data;
    },
    [getAIChatHistory.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAllAkademyIndicatorStatutories.pending]: (state) => {
      state.loading = true;
    },
    [getAllAkademyIndicatorStatutories.fulfilled]: (state, action) => {
      state.loading = false;
      state.indicatorStatutories = action.payload.data;
    },
    [getAllAkademyIndicatorStatutories.rejected]: (state) => {
      state.loading = false;
    },
    ///////////////// curriculum v2 /////////////////
    // These five read `action.payload` directly — the v2 handlers return the document or
    // array with no `{ data }` envelope. See the note above `CURRICULUM_V2`.
    [getAllCurriculumFrameworks.pending]: (state) => {
      state.loading = true;
    },
    [getAllCurriculumFrameworks.fulfilled]: (state, action) => {
      state.loading = false;
      state.curriculumFrameworks = action.payload;
    },
    [getAllCurriculumFrameworks.rejected]: (state) => {
      state.loading = false;
    },
    [getCurriculumNodes.pending]: (state) => {
      state.loading = true;
    },
    [getCurriculumNodes.fulfilled]: (state, action) => {
      state.loading = false;
      state.curriculumNodes = action.payload;
    },
    [getCurriculumNodes.rejected]: (state) => {
      state.loading = false;
    },
    [getCurriculumAgeGroups.pending]: (state) => {
      state.loading = true;
    },
    [getCurriculumAgeGroups.fulfilled]: (state, action) => {
      state.loading = false;
      state.curriculumAgeGroups = action.payload;
    },
    [getCurriculumAgeGroups.rejected]: (state) => {
      state.loading = false;
    },
    [getCurriculumRatingScales.pending]: (state) => {
      state.loading = true;
    },
    [getCurriculumRatingScales.fulfilled]: (state, action) => {
      state.loading = false;
      state.curriculumRatingScales = action.payload;
    },
    [getCurriculumRatingScales.rejected]: (state) => {
      state.loading = false;
    },
    [getCurriculumActionSuggestions.pending]: (state) => {
      state.loading = true;
    },
    [getCurriculumActionSuggestions.fulfilled]: (state, action) => {
      state.loading = false;
      state.curriculumActionSuggestions = action.payload;
    },
    [getCurriculumActionSuggestions.rejected]: (state) => {
      state.loading = false;
    },
    // storage plans
    [createStoragePlanAsync.pending]: (state) => {
      state.loading = true;
    },
    [createStoragePlanAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createStoragePlanAsync.rejected]: (state) => {
      state.loading = false;
    },
    [allStoragePlanAsync.pending]: (state) => {
      state.loading = true;
    },
    [allStoragePlanAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.allPlans = action.payload;
    },
    [allStoragePlanAsync.rejected]: (state) => {
      state.loading = false;
    },
    // Token plans
    [createTokenPlanAsync.pending]: (state) => {
      state.loading = true;
    },
    [createTokenPlanAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createTokenPlanAsync.rejected]: (state) => {
      state.loading = false;
    },
    [allTokenPlanAsync.pending]: (state) => {
      state.loading = true;
    },
    [allTokenPlanAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.allTokenPlans = action.payload;
    },
    [allTokenPlanAsync.rejected]: (state) => {
      state.loading = false;
    },
    /////////////////////////////////////////
    [getAkadmyWidgetConfig.pending]: (state) => {
      state.widgetConfig.isLoading = true;
      state.widgetConfig.isError = false;
    },
    [getAkadmyWidgetConfig.fulfilled]: (state, action) => {
      state.widgetConfig.isLoading = false;
      state.widgetConfig.data = action.payload.widgetConfig;
    },
    [getAkadmyWidgetConfig.rejected]: (state) => {
      state.widgetConfig.isLoading = false;
      state.widgetConfig.isError = true;
      state.widgetConfig.data = null;
    },
    /////////////////////////////////////////
    [getAkadmySchoolAnalytics.pending]: (state) => {
      state.school.isLoading = true;
    },
    [getAkadmySchoolAnalytics.fulfilled]: (state, action) => {
      state.school.isLoading = false;
    },
    [getAkadmySchoolAnalytics.rejected]: (state) => {
      state.school.isLoading = false;
    },
  },
});

export default akademySlice.reducer;
